import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { composeWithDevTools } from '@redux-devtools/extension';

import rootReducer from './rootReducer';
import analyticsMiddleware from '../firstVisit/analyticsMiddleware';

const configureStore = () => {
  // analytics only observes actions (Sol mixpanel-coverage D1 A); it is a no-op without a web Mixpanel token
  const middleware = [thunk, analyticsMiddleware];
  if (process.env.NODE_ENV !== 'production') {
    middleware.push(
      createLogger({
        // Overlay actions can be extremely high-frequency (Unity can emit them per-frame),
        // especially when toggling viewboard fullscreen. Exclude them from console spam.
        predicate: (_getState, action) => {
          const noisy = new Set([
            'UPDATE_TEXT_OVERLAY',
            'REMOVE_TEXT_OVERLAY',
            'CLEAR_TEXT_OVERLAYS',
            // Unity lesson bridge actions can also be high-frequency; logging prev/next
            // state for these can crash DevTools / the tab.
            'SET_LESSON_BUTTON_VISIBILITY',
            'SET_LESSON_BUTTON_INTERACTION',
            'SET_LESSON_PIECE_TEXT',
            'SET_LESSON_PAUSED',
            'RESET_LESSON_BUTTON_INTERACTION',
          ]);
          return !noisy.has(action?.type);
        },
      }),
    );
  }

  const enhancer =
    process.env.NODE_ENV === 'production'
      ? applyMiddleware(...middleware)
      : composeWithDevTools(applyMiddleware(...middleware));

  return createStore(rootReducer, enhancer);
};

export default configureStore;
